import React from "react";
import { Panel } from "@vkontakte/vkui";
import Text from "@vkontakte/vkui/dist/components/Typography/Text/Text";
import Div from "@vkontakte/vkui/dist/components/Div/Div";
import styles from "./loginPanel.style";
import LoginForm from "./LoginForm";
import GosuslugiLogo from "../../img/logo.svg";
import css from "./LoginPanel.module.scss";

const LogInPanel = ({ id }) => {
  return (
    <Panel id={id}>
      <Div className={css.headerWrapper}>
        <img style={styles.logo} src={GosuslugiLogo} alt="logo" />
        <Text style={styles.secondHeader}>Единая система</Text>
        <Text style={styles.secondHeader}> идентификации и аутентификации</Text>
      </Div>
      <Div style={styles.formHeaderWrapper}>
        <Text weight={"regular"} style={styles.formHeaderH1}>
          Вход
        </Text>
        <Text weight={"regular"} style={styles.formHeaderH2}>
          для портала Госуслуг
        </Text>
      </Div>
      <LoginForm />
    </Panel>
  );
};

export default LogInPanel;
